const LEVEL_LABELS = {
  básico: 'Básico',
  intermedio: 'Intermedio',
  avanzado: 'Avanzado',
  experto: 'Experto',
};

export function getLevelLabel(level) {
  return LEVEL_LABELS[level?.toLowerCase()] ?? level ?? '—';
}

export function getPatternSkillRequirements(pattern) {
  if (!pattern) return [];
  const reqs = pattern.SkillRequirements ?? pattern.skill_requirements ?? [];
  return Array.isArray(reqs) ? reqs : [];
}

export function filterRequirementsByDate(requirements, dateStr) {
  if (!dateStr) return requirements;
  const target = new Date(`${dateStr}T12:00:00`);
  return requirements.filter((req) => {
    const from = new Date(req.valid_from);
    const to = req.valid_to ? new Date(req.valid_to) : null;
    return from <= target && (!to || to >= target);
  });
}

export function isCoverageFullyCovered(data) {
  return data?.status === 'fully covered';
}

export function getCoverageMissingSkills(data) {
  if (isCoverageFullyCovered(data)) return [];
  const missing = data?.MissingSkills ?? data?.missing_skills ?? [];
  return Array.isArray(missing) ? missing : [];
}

export function formatRequirementDate(iso) {
  if (!iso) return '—';
  try {
    return new Date(iso).toLocaleDateString('es-ES');
  } catch {
    return '—';
  }
}
